import type { FaireProductEntity } from "../../entity_types/product";

export const p_jr9k6mkpqh: FaireProductEntity = {
  token: "p_jr9k6mkpqh",
  type: "product",
  name: "Caribbean Calcite aka Blue Aragonite Sphere Set 117g/43mm",
  brandToken: "b_hjv6mwysyg",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/a5e5c3b7a91217619711b5d955a412b266776c5f1e1c886dd770c9fb87ddef34.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a34234b475feaed59a4eda88e57c7d16485e880db8e1e83e342cc2abc9b5846.jpeg",
    "https://cdn.faire.com/fastly/d6cabf20eb060c5be06fc4ef3595617f1cea443a77e5c1a5f79b9e0211f6267c.jpeg",
    "https://cdn.faire.com/fastly/47680f7aab5d27fcb5ed881c8a23c6ded3439ae7bc131264acdd55a639814582.jpeg",
    "https://cdn.faire.com/fastly/e9c38c06329215981e3b60b8cf149fee99d4573bfc79a1e956f50abab6fcd0bb.jpeg",
  ],
  priceDollars: 21.48,
  description:
    "Caribbean Calcite Crystal Sphere Gift Set with Selenite Piece for cleansing and clearing is a metaphysical healing product that combines the powerful energies of Caribbean Calcite and Selenite to promote emotional balance, stress relief, and spiritual growth. Caribbean Calcite helps us access our inner vision and connect to our higher selves, to gain a sense of purpose, a true sense of self, and begin a journey of ultimate self-discovery. It is a helpful stone during times of new beginnings and personal growth. A calming stone, Caribbean Calcite encourages us to live in the present moment. Selenite is a powerful stone that is known for its ability to cleanse and clear the mind and body of negative energy. It is also believed to promote emotional balance, stress relief, and spiritual growth. \n\nSet Includes:\nCaribbean Calcite sphere\nAcrylic Stand\nSelenite Piece\nInformational Cards\n\n***Please note that these are natural items and will have natural lines and inclusions.",
  tags: [],
  msrpDollars: 42.96,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:55.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
